import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import StyledLink from "./small-styled-link";

const CategoriesList = () => {
  const data = useStaticQuery(graphql`
    query AllCategories {
      allMarkdownRemark(limit: 2000) {
        group(field: frontmatter___tags) {
          fieldValue
          totalCount
        }
      }
    }
  `);
  const cats = data.allMarkdownRemark.group;

  return (
    <div>
      <h3 className="text-2xl font-bold font-title">Categories</h3>
      <ol className="list-decimal list-inside text-gray-700">
        {cats.map(({ fieldValue, totalCount }) => {
          return (
            <li className="text-md" key={fieldValue}>
              <StyledLink to={`/blog/tag/${fieldValue}`}>
                {fieldValue}
              </StyledLink>{" "}
              <span className="text-sm text-gray-500">({totalCount})</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default CategoriesList;
